import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/salesData';
export function ProblemSection() {
  return <section className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-185" data-mp="30gxu3xcr9fmr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-186" data-mp="30jahwr572k7q">
        <SectionHeading data-id="element-187" data-mp="2vq7s8u3jfuwt">¿Cuántos lunes más vas a volver a empezar?</SectionHeading>

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-white/75" data-id="element-188" data-mp="39hcs9xatip7o">
          <p data-id="element-189" data-mp="39jqjfv2dnh9y">
            Querés sentirte mejor y que la ropa te quede como antes. Ya lo
            intentaste. Y siempre pasó lo mismo: primera semana perfecta y
            después la vida real — el trabajo, el cansancio, la heladera vacía.
          </p>
          <p className="text-lg font-semibold text-[var(--lilac-light)]" data-id="element-190" data-mp="3eia8w5g6jb72">
            No te falta fuerza de voluntad. Te falta un sistema.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-191" data-mp="1k3heg9r18qgp">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-[var(--violet)]/25 bg-[var(--violet)]/[0.07] p-4" data-id="element-192" data-mp="je6e2utcgc6t">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--violet)]/25" data-id="element-193" data-mp="sd9v7t8yahio">
                <XIcon className="h-4 w-4 text-[var(--violet-light)]" aria-hidden="true" data-id="element-194" data-mp="x5bhm7zu1omf" />
              </span>
              <span className="text-white/70" data-id="element-195" data-mp="172fvlkjiyds5">{point}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold text-[var(--cream)] sm:text-3xl" data-id="element-196" data-mp="1c228ttzcru0y">
          ¿Y si este fuera el último lunes que empezás de cero?
        </p>
      </div>
    </section>;
}